<template>
  <div>
    <NavMenu />
    <div class="page-content">
      <div v-if="busy" class="busy-container"><BusySpinner /></div>
      <div v-else>
        <form class="form" @submit="copyProject">
          <div class="fields">
            <input type="text" placeholder="Share Link" v-model="link" required />
            <textarea placeholder="Comment" v-model="comment"></textarea>
          </div>
          <button type="submit">{{ submitText }}</button>
        </form>
        <div v-if="warning" class="warning">
           {{ warning }}
        </div>
        <div v-if="prodProject && stagingProject" class="summary">
            <table>
              <tr>
                <th class="field-name">Field</th>
                <th>Production</th>
                <th>Staging</th>
              </tr>
              <tr v-for="(field, index) in fields" :key="index">
                <td>{{ field }}</td>
                <td v-if="urlFields.includes(field)"><a :href="prodProject[field]" target="_blank">{{ prodProject[field] }} </a></td>
                <td v-else>{{ prodProject[field] }}</td>
                <td v-if="urlFields.includes(field)"><a :href="stagingProject[field]" target="_blank">{{ stagingProject[field] }} </a></td>
                <td v-else>{{ stagingProject[field] }}</td>
              </tr>
            </table>
        </div>
        <div v-if="error" class="error">
           {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'
import BusySpinner from '@/components/BusySpinner.vue'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  name: 'Copy',
  components: { NavMenu, BusySpinner },
  data: ()=>({
    busy: false,
    link: '',
    comment: '',
    prodProject: null,
    stagingProject: null,
    submitText: 'Sync Project Staging / Production',
    urlFields: [
        'largeThumbUrl',
        'tinyThumbUrl',
        'Download Link',
        'smallThumbUrl',
        'medThumbUrl',
    ],
    fields: [],//TODO: ordering
    error: '',
    warning: '',
    prechecked: true
  }),
  watch: {
    link () {
        this.reset()
    }
  },
  methods: {
    reset() {
      this.error = ''
      this.warning = ''
      this.prodProject = null
      this.stagingProject = null
      this.prechecked = true
      this.submitText = 'Sync Project Staging / Production'
    },
    copyProject(e) {
      const curl = window.location.href
      if (curl.includes("localhost") || curl.includes("0.0.0.0")) {
          firebase.functions().useFunctionsEmulator("http://0.0.0.0:5001")
      }
      e.preventDefault()
      const endpoint = firebase.functions().httpsCallable('copyProject')
      const [link, comment] = [this.link, this.comment]
      this.busy = true
      endpoint({link, comment, precheck: this.prechecked}).then((res) => {
        this.busy = false
        const directionText = res.data.toStaging ? 'Production ⟶   Staging' : 'Staging ⟶   Production'
        switch (res.data.status) {
            case "no-record":
                this.warning = res.data.comment
            break
            case "success":
                this.prodProject = res.data.data.prod
                this.stagingProject = res.data.data.staging
                this.fields = Object.keys(this.stagingProject)
                this.error = ''
                this.warning = ''
            break
            case "warning":
                this.prechecked = false
                this.warning = res.data.comment
                this.prodProject = res.data.data.prod
                this.stagingProject = res.data.data.staging
                this.fields = Object.keys(this.stagingProject)
                this.submitText = `Overwrite ${ directionText }`
            break
        }
      }).catch((error) => {
        this.busy = false
        this.error = error
      });
    }
  }
}
</script>

<style lang="scss" scoped>
$blue:    #0d6efd;
$indigo:  #6610f2;
$purple:  #6f42c1;
$pink:    #d63384;
$red:     #dc3545;
$orange:  #fd7e14;
$yellow:  #ffc107;
$green:   #198754;
$teal:    #20c997;
$cyan:    #0dcaf0;

th {
    width: 30vw;
}

.field-name {
    max-width: 150px;
}

td[colspan="2"] {
    text-align: center;
}

.busy-container {
  display: flex;
  justify-content: center;
}

.summary {
    margin-top: 15px;
}

.warning {
    margin-top: 15px;
    color: $orange;
}

.error {
    margin-top: 15px;
    color: $red;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 0.8em;
}

td, th {
  border: 1px solid #BBB;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
.form {
  display: flex;
  border-bottom: 1px solid #AAA;
  padding-left: 10pt;
  padding-right: 10pt;
  padding-bottom: 8pt;
  margin-left: -10pt;
  margin-right: -10pt;
  .fields {
    flex-grow: 1;
  }
  textarea {
    margin-top: 10px;
  }
  input, textarea {
    width: 100%;
    font-size: 13pt;
    border: 2px solid #BBB;
    border-radius: 2pt;
    padding: 3pt;
  }
  input:focus-visible, textarea:focus-visible {
    border: 2px solid rgb(116, 114, 148);
  }
  input::placeholder, textarea::placeholder {
    color: #BBB;
  }
  button {
    font-size: 12pt;
    max-width: 80pt;
    padding: 3pt;
    margin-left: 20px;
    margin-bottom: 5px;
  }
}
</style>
